import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AppConfig } from 'src/app/config';
import { map } from 'rxjs/operators';

@Injectable()
export class AuthService {
  loggedIn: boolean;
  token: any;
  headers = new HttpHeaders();

  constructor(private router: Router, private http: HttpClient) {
    this.headers.append('x-access-token', sessionStorage.getItem('token'));
    this.imaToken();
  }

  login(a: any) {
    return this.http
      .post(AppConfig.ipAddress + 'prijavaweb', a, { headers: this.headers })
      .pipe(map((res: any) => res));
  }

  pravaKorisnika(a: any) {
    return this.http
      .post(AppConfig.ipAddress + 'prijavaprava', a)
      .pipe(map((res: any) => res));
  }

  imaToken() {
    this.token = sessionStorage.getItem('token');
    if (this.token != null || this.token != undefined) {
      this.loggedIn = true;
      this.router.navigate(['/nadzorna-ploca']);
    } else {
      this.loggedIn = false;
    }
  }

  logIn(login: string, password: string) {
    this.loggedIn = true;
    this.router.navigate(['/nadzorna-ploca']);
  }

  // logOut() {
  //   this.loggedIn = false;
  //   this.router.navigate(['/login-form']);
  //   localStorage.clear();
  //   sessionStorage.clear();
  // }

  logOut() {
    this.loggedIn = false;
    // this.korisnik = localStorage.getItem("iduser");
    // this.router.navigate(["/moduli"]);
    // this.router.navigate(["/moduli/" + this.korisnik]);
    localStorage.clear();
    sessionStorage.clear();
    window.close();
  }

  get isLoggedIn() {
    return this.loggedIn;
  }

  konvertiraj() {
    return {
      konvertiraj_3decimal(_a: any) {
        var a = _a;
        var predznak = '';
        if (typeof a == 'number') {
          if (isNaN(a) || a === Infinity) {
            var str = '';
          } else {
            var str = String(a);
          }
        } else if (typeof a == 'string') {
          var str = a;
        } else {
          var str = '';
        }

        if (str.indexOf('-') == 0) {
          str = str.substring(1, str.length);
          predznak = '-';
        }

        var duzina = str.length;
        var tocka = str.indexOf('.');
        var zarez = str.indexOf(',');

        if (tocka > 0) {
          var decimalnomjesto = tocka;
        } else if (zarez > 0) {
          var decimalnomjesto = zarez;
        } else {
          var decimalnomjesto = -1;
        }
        if (typeof str == 'string') {
          if (decimalnomjesto > 0) {
            if (decimalnomjesto > 3) {
              var brojevi = '';
              var broj = 0;
              for (var i = 3; i < decimalnomjesto; i = i + 3) {
                brojevi =
                  '.' +
                  str.substring(
                    decimalnomjesto - i,
                    decimalnomjesto - (i - 3)
                  ) +
                  brojevi;
                broj = i;
              }
              var prvi = str.substring(0, decimalnomjesto - broj) + brojevi;
            } else {
              var prvi = str.substring(0, decimalnomjesto);
            }
            if (decimalnomjesto == duzina - 2) {
              var decimal = str.substring(decimalnomjesto + 1, duzina) + '0';
            } else {
              var decimal = str.substring(
                decimalnomjesto + 1,
                decimalnomjesto + 3
              );
            }
            var ukupno = prvi + ',' + decimal;
            return predznak + ukupno;
          } else {
            if (duzina > 3) {
              var brojevi = '';
              var broj = 0;
              for (var i = 3; i < duzina; i = i + 3) {
                brojevi =
                  '.' + str.substring(duzina - i, duzina - (i - 3)) + brojevi;
                broj = i;
              }
              var prvi = str.substring(0, duzina - broj) + brojevi;
              var decimal = '000';
              var ukupno = prvi + ',' + decimal;
              return predznak + ukupno;
            } else {
              var decimal = '000';
              if (str == '') {
                str = '0';
              }
              var ukupno = str + ',' + decimal;
              return predznak + ukupno;
            }
          }
        }
      },
    };
  }

  konvertirajCijenu() {
    return {
      konvertiraj(_a: any) {
        var a = _a;
        var predznak = '';
        if (typeof a == 'number') {
          if (isNaN(a) || a === Infinity) {
            var str = '';
          } else {
            var str = String(a);
          }
        } else if (typeof a == 'string') {
          var str = a;
        } else {
          var str = '';
        }

        if (str.indexOf('-') == 0) {
          str = str.substring(1, str.length);
          predznak = '-';
        }

        var duzina = str.length;
        var tocka = str.indexOf('.');
        var zarez = str.indexOf(',');

        if (tocka > 0) {
          var decimalnomjesto = tocka;
        } else if (zarez > 0) {
          var decimalnomjesto = zarez;
        } else {
          var decimalnomjesto = -1;
        }
        if (typeof str == 'string') {
          if (decimalnomjesto > 0) {
            if (decimalnomjesto > 3) {
              var brojevi = '';
              var broj = 0;
              for (var i = 3; i < decimalnomjesto; i = i + 3) {
                brojevi =
                  '.' +
                  str.substring(
                    decimalnomjesto - i,
                    decimalnomjesto - (i - 3)
                  ) +
                  brojevi;
                broj = i;
              }
              var prvi = str.substring(0, decimalnomjesto - broj) + brojevi;
            } else {
              var prvi = str.substring(0, decimalnomjesto);
            }
            if (decimalnomjesto == duzina - 2) {
              var decimal = str.substring(decimalnomjesto + 1, duzina) + '0';
            } else {
              var decimal = str.substring(
                decimalnomjesto + 1,
                decimalnomjesto + 3
              );
            }
            var ukupno = prvi + ',' + decimal;
            return predznak + ukupno;
          } else {
            if (duzina > 3) {
              var brojevi = '';
              var broj = 0;
              for (var i = 3; i < duzina; i = i + 3) {
                brojevi =
                  '.' + str.substring(duzina - i, duzina - (i - 3)) + brojevi;
                broj = i;
              }
              var prvi = str.substring(0, duzina - broj) + brojevi;
              var decimal = '00';
              var ukupno = prvi + ',' + decimal;
              return predznak + ukupno;
            } else {
              var decimal = '00';
              if (str == '') {
                str = '0';
              }
              var ukupno = str + ',' + decimal;
              return predznak + ukupno;
            }
          }
        }
      },
    };
  }

  formatiraj(broj, brojDecimala) {
    return new Intl.NumberFormat('hr-HR', {
      minimumFractionDigits: brojDecimala,
      maximumFractionDigits: brojDecimala,
    }).format(broj);
  }
}

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const firma = parseInt(localStorage.getItem('firma'));
    const isLoggedIn = this.authService.loggedIn;
    const isAuthForm = [
      'login-form',
      'reset-password',
      'create-account',
      'change-password/:recoveryCode',
    ].includes(route.routeConfig.path);
    // console.log(isLoggedIn)
    // console.log(isAuthForm)
    if (isLoggedIn && isAuthForm) {
      this.router.navigate(['/nadzorna-ploca']);
      // this.authService.lastAuthenticatedPath = defaultPath;
      // this.router.navigate([defaultPath]);
      return false;
    }

    if (!isLoggedIn && !isAuthForm) {
      this.router.navigate(['/login-form']);
    }

    return isLoggedIn || isAuthForm;
  }
}
